import script from "./BaseAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAlert.vue?vue&type=style&index=0&id=3f497a88&lang=scss&scoped=true"

import exportComponent from "/var/www/braintreewellbeing.org/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f497a88"]])

export default __exports__